<template>
    <v-dialog v-model="isOpen" max-width="700" transition="slide-y-transition" eager>
        <v-card>
            <v-card-title class="px-10 pt-7 pb-1">
                <h1 class="text-subtitle-1 mb-0">
                    {{ t('common.releaseNotes.title') }}
                    <strong>{{ latestVersion?.number }}</strong
                    >:
                </h1>
            </v-card-title>

            <v-card-text class="px-10 pt-2 pb-7">
                <v-list v-if="latestVersion?.changes?.length" density="compact" class="py-0">
                    <v-list-item v-for="(change, index) in sortedChanges" :key="change.id" class="px-0 py-2">
                        <v-row no-gutters align="start">
                            <v-col cols="2" sm="1" class="text-body-2 font-weight-medium pe-6 text-right">
                                {{ index + 1 }}.
                            </v-col>
                            <v-col cols="10" sm="11" class="text-body-2">
                                {{ change.description }}
                            </v-col>
                        </v-row>
                    </v-list-item>
                </v-list>
            </v-card-text>

            <v-divider />

            <v-card-actions class="px-6 py-3">
                <v-spacer />
                <v-btn color="primary" variant="text" @click="isOpen = false">
                    {{ t('common.buttons.close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script setup lang="ts">
/*
Organization / ordering applied:
1. Imports
2. Props / Emits
3. Constants
4. Stores & top-level services
5. Reactive state (refs/reactive)
6. Validation rules & setup
7. Computed
8. Handlers / methods
9. Helpers / lifecycle
*/

// 1. Imports
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { ReleaseNoteChangeResponseSchema, ReleaseNoteVersionResponseSchema } from '@/api/schemas/releaseNotes/releaseNotes'

// 2. Props / Emits
const isOpen = defineModel<boolean>()

const props = defineProps<{
    latestVersion?: ReleaseNoteVersionResponseSchema | null
}>()

// 3. Constants
// (none)

// 4. Stores & top-level services
const { t } = useI18n()

// 5. Reactive state (refs/reactive)
// (none)

// 6. Validation rules & setup
// (none)

// 7. Computed
const sortedChanges = computed<ReleaseNoteChangeResponseSchema[]>(() => {
    const changes = props.latestVersion?.changes
    if (!changes) {
        return []
    }

    return [...changes].sort((a, b) => a.sortOrder - b.sortOrder)
})

// 8. Handlers / methods
// (none)

// 9. Helpers / lifecycle
// (none)
</script>
